import React from 'react';

export default function WholesalePartnerSection({ sectionData }) {
    const { title, body, bodyBold, tagline } = sectionData || {};

    return (
        <section className="w-full bg-white py-14 md:py-18 lg:py-20 px-5 md:px-6">
            <div className="max-w-5xl mx-auto text-center">

                {title && (
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-950 leading-[1.08] mb-6 whitespace-pre-line">
                        {title}
                    </h2>
                )}

                <div className="max-w-3xl mx-auto">
                    {body && (
                        <p className="text-base md:text-lg text-primary-950/80 font-medium leading-7 mb-2">
                            {body}
                        </p>
                    )}

                    {bodyBold && (
                        <p className="text-base md:text-lg text-primary-950 font-bold leading-7 mb-7">
                            {bodyBold}
                        </p>
                    )}
                </div>

                {tagline && (
                    <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-500 leading-tight transition-transform duration-500 hover:scale-[1.02]">
                        {tagline}
                    </h3>
                )}

            </div>
        </section>
    );
}